import React from 'react';
import { BookOpen, CheckSquare, Clock, Book, Image as ImageIcon } from 'lucide-react';
import { InlineCTA } from './InlineCTA';
export function WhatYouGetSection() {
  const items = [{
    icon: <BookOpen className="w-6 h-6 text-[#4A6741]" data-id="element-191" />,
    title: 'Guía Digital Protocolo SOS',
    desc: 'Instrucciones claras de qué hacer antes, durante y después.'
  }, {
    icon: <CheckSquare className="w-6 h-6 text-[#4A6741]" data-id="element-192" />,
    title: 'Checklist de Mochila Sensorial',
    desc: 'Los esenciales exactos para prevenir crisis en salidas.'
  }, {
    icon: <Clock className="w-6 h-6 text-[#4A6741]" data-id="element-193" />,
    title: 'Plan de Acción de 60 Segundos',
    desc: 'Tus primeros pasos cuando empieza el descontrol.'
  }, {
    icon: <Book className="w-6 h-6 text-[#4A6741]" data-id="element-194" />,
    title: 'Diario de Disparadores',
    desc: 'Plantilla para detectar patrones y anticiparte al caos.'
  }, {
    icon: <ImageIcon className="w-6 h-6 text-[#4A6741]" data-id="element-195" />,
    title: 'Tarjeta Visual Imprimible',
    desc: 'Apoyo visual rápido para comunicarte sin hablar de más.'
  }];
  return <section className="bg-[#FDF8F0] pt-16 pb-6 md:py-24 px-5" data-id="element-196">
      <div className="max-w-5xl mx-auto" data-id="element-197">
        <div className="text-center mb-10" data-id="element-198">
          <h2 className="text-2xl md:text-4xl font-bold text-[#2D1F0E] mb-4" data-id="element-199">
            Todo lo que necesitas para dejar de improvisar en cada crisis
          </h2>
          <p className="text-[1.05rem] md:text-xl text-[#6B5D4F] leading-relaxed" data-id="element-200">
            Herramientas prácticas, rápidas y fáciles de usar en casa o en
            público.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-201">
          {items.map((item, idx) => <div key={idx} className={`bg-white p-5 md:p-8 rounded-2xl shadow-sm border border-[#D4A853]/20 flex flex-col items-start ${idx === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-202">
              <div className="w-10 h-10 bg-[#F0F4EC] rounded-xl flex items-center justify-center mb-4" data-id="element-203">
                {item.icon}
              </div>
              <h3 className="text-lg font-bold text-[#2D1F0E] mb-2" data-id="element-204">
                {item.title}
              </h3>
              <p className="text-[#6B5D4F] text-[0.9rem] md:text-base leading-relaxed" data-id="element-205">
                {item.desc}
              </p>
            </div>)}
        </div>

        <div className="mt-6 md:mt-8" data-id="element-206">
          <InlineCTA text="Quiero recuperar la calma" data-id="element-207" />
        </div>
      </div>
    </section>;
}